import { LEVEL_BAND, LEVEL_BANDS } from '../utils/schedConstants';

// Ascending "rank meter": four slots, the first (band + 1) filled, each bar taller
// than the last (Staff = 1 short bar … Leadership = 4 bars ending tall). Count AND the
// rising silhouette both encode seniority, so it reads without counting and 3-vs-4 is
// unambiguous — replaces the old darker-shade-by-level scheme, whose bands were too
// close to tell apart. Used wherever a staff identity swatch renders on the grid.
const BAR_HEIGHTS = [4, 6, 8, 10]; // px, ascending — slot index 0..3

/**
 * @param {string} level  raw staff level string (mapped to a 0–3 band via LEVEL_BAND)
 * @param {string} color  bar color (e.g. '#fff' on a colored block, or the dept hue on
 *                         a white background). Filled bars are opaque, empty slots faint.
 * @param {boolean} onFill add a subtle dark halo so white bars read on light dept hues.
 * @param {string} title  optional tooltip override (defaults to the band label).
 */
export default function SeniorityBars({ level, band: bandProp, color = 'currentColor', onFill = false, title, style }) {
  const band = bandProp != null ? bandProp : LEVEL_BAND(level); // 0..3
  const filled = band + 1;                         // 1..4 bars lit
  const label = (LEVEL_BANDS.find(b => b.band === band) || {}).label || 'Staff';
  return (
    <span
      className={`sched-seniority-bars${onFill ? ' sched-seniority-bars--on-fill' : ''}`}
      style={style}
      title={title || `Level: ${label}`}
      role="img"
      aria-label={`Seniority: ${label}`}
    >
      {BAR_HEIGHTS.map((h, i) => (
        <span
          key={i}
          className="sched-seniority-bar"
          style={{ height: h, background: color, opacity: i < filled ? 1 : 0.22 }}
        />
      ))}
    </span>
  );
}
